export function capForYear(respiteCaps, startYear) {
  if (!respiteCaps) return null;
  const found = respiteCaps.find((c) => c.startYear === startYear);
  return found ? found.amount : null;
}

export function performanceYearOf(date) {
  const d = new Date(date);
  const y = d.getUTCFullYear();
  const startYear = d.getUTCMonth() >= 6 ? y : y - 1;
  return { label: `${startYear}–${startYear + 1}`, startYear };
}

export function groupByPerformanceYear(transactions) {
  const groups = {};
  transactions.forEach((t) => {
    const { label, startYear } = performanceYearOf(t.date);
    if (!groups[label]) {
      groups[label] = { label, startYear, txns: [], subtotal: 0 };
    }
    groups[label].txns.push(t);
    groups[label].subtotal += Number(t.amount) || 0;
  });

  const sorted = Object.values(groups).sort((a, b) => b.startYear - a.startYear);
  sorted.forEach((g) => g.txns.sort((x, y) => x.date < y.date ? 1 : -1));
  return sorted;
}
